import React from 'react';
import { useTranslation } from 'react-i18next';
import { Regions } from '../../hooks/useConfiguration';
import { assertNever } from '../../utils/assertNever';

export const Contact: React.FC<{
  region: Regions;
}> = ({ region }) => {
  const { t } = useTranslation();

  switch (region) {
    case 'us':
      return (
        <>
          <h3 className='contacts-list__title'>{t('imprint.contactsList.contacts.title')}</h3>
          <div className='contacts-list__text nowrap'>
            {t('imprint.contactsList.contacts.phone')} +1 (800) 261 6531
            <br />
            {t('imprint.contactsList.contacts.email')} <a href='mailto:info@lm-americas.com'>info@lm-americas.com</a>
          </div>
        </>
      );
    case 'eu':
      return (
        <>
          <h3 className='contacts-list__title'>{t('imprint.contactsList.contacts.title')}</h3>
          <div className='contacts-list__text nowrap'>
            {t('imprint.contactsList.contacts.phone')} +49 (0) 40 54702 0<br />
            {t('imprint.contactsList.contacts.fax')} +49 (0) 40 54702-461
            <br />
            {t('imprint.contactsList.contacts.email')}{' '}
            <a href='mailto:info@loewensteinmedical.de'>info@loewensteinmedical.de</a>
          </div>
        </>
      );
    default:
      assertNever(region);
  }
};
